import template from './preguntas.component.html';
import angular from 'angular';
import './preguntas.repository';

angular
    .module('Toke')
    .component('appPreguntas', {
        template,
        bindings: {
            data: '<'
        },
        controller: PreguntasController
    });

PreguntasController.$inject = ['preguntasRepository'];

function PreguntasController(preguntasRepository) {

    const vm = this;


    vm.preguntas = {};


    vm.toggle = toggle;


    vm.$onInit = function () {

        // si vienen por binding
        if (vm.data) {
            vm.preguntas = vm.data;
            prepareItems();
            return;
        }

        // si vienen del repo
        preguntasRepository
            .getPreguntas()
            .then(res => {
                vm.preguntas = res || {};
                prepareItems();
            });
    };




    // agrega estado open a cada item
    function prepareItems() {

        if (!vm.preguntas.items) return;

        vm.preguntas.items = vm.preguntas.items.map(item => ({
            ...item,
            open: false
        }));
    }



    function toggle(selectedItem) {

        vm.preguntas.items.forEach(item => {
            item.open = item === selectedItem ? !item.open : false;
        });
    }
}
